export type SearchActionKind = "filterGrid";

export interface SearchActionRow {
	icon: string;
	key: string;
	kind: SearchActionKind;
	label: string;
	term: string;
}

interface DeriveSearchActionRowsArgs {
	explicit: boolean;
	hasActiveGrid: boolean;
	query: string;
}

const deriveSearchActionRows = ({ explicit, hasActiveGrid, query }: DeriveSearchActionRowsArgs): SearchActionRow[] => {
	const term = query.trim();
	if (!term || explicit || !hasActiveGrid) {
		return [];
	}
	return [
		{
			icon: "filter_alt",
			key: "filter-grid",
			kind: "filterGrid",
			label: `Filter this grid for "${term}"`,
			term
		}
	];
};

export default deriveSearchActionRows;
